import { BillingAccount } from '../../pages/arc/features/billing-accounts/billing-accounts-models';

export enum TcsmReduxSessionStorageKeys {
	EMPLOYEE_SELECT = 'EMPLOYEE_SELECT',
	INSTITUTION_SELECT = 'INSTITUTION_SELECT',
	GROUP_SELECT = 'GROUP_SELECT',
	BILLING_ACCOUNT_SELECT = 'BILLING_ACCOUNT_SELECT',
	PARTICIPANT_SELECT = 'PARTICIPANT_SELECT',
	GROUP_ADMIN_SELECT = 'GROUP_ADMIN_SELECT',
	INSTITUTION_ADMIN_SELECT = 'INSTITUTION_ADMIN_SELECT',
}

export interface BillingAccountSessionStorageState {

	billingAccount: BillingAccount,
	clientNumber: string,

}

export interface InstitutionSessionStorageState {
	institutionId: string,
	guid: string,
}

export function SaveToSessionStorage(key: TcsmReduxSessionStorageKeys, value: any) {
	sessionStorage.setItem(key, value);
}

export function GetSessionStorageValue(key: TcsmReduxSessionStorageKeys) {
	return sessionStorage.getItem(key);
}

export function ClearTcsmSessionStorage(skipGroup?: boolean) {
	sessionStorage.removeItem(TcsmReduxSessionStorageKeys.EMPLOYEE_SELECT);
	sessionStorage.removeItem(TcsmReduxSessionStorageKeys.INSTITUTION_SELECT);
	if (!skipGroup) sessionStorage.removeItem(TcsmReduxSessionStorageKeys.GROUP_SELECT);
	sessionStorage.removeItem(TcsmReduxSessionStorageKeys.BILLING_ACCOUNT_SELECT);
	sessionStorage.removeItem(TcsmReduxSessionStorageKeys.PARTICIPANT_SELECT);
	sessionStorage.removeItem(TcsmReduxSessionStorageKeys.GROUP_ADMIN_SELECT);
	sessionStorage.removeItem(TcsmReduxSessionStorageKeys.INSTITUTION_ADMIN_SELECT);
}